module.exports = Em.View.extend({
    templateName: 'daybook/transaction-summary',

    classNames: ['daybook-transaction-summary']
})
